import { Component } from "react";
import Layout from "../../component/layout";
import NextSeoModule from "../../component/next-seo";
import Gotemplate from "../../component/course/go";

export default class Goinchennai extends Component {
 
  render() {
   
    const title = "Go Language"   
    const url ="go"
     const url1 ="-training-in-chennai"
    const location = "chennai" 
    const location1="Training in Chennai"
    
     return(
      <>
          <NextSeoModule
          title={`${title} ${location1} - learnsoft.org`}
            description={`Learn the basics and advanced concepts of Go Lang programming language with hands-on ${location1}. Get certified and enhance your skills with industry-relevant curriculum and experienced trainers`}
           url={`course/${url}${url1}`}
            img={`course/${url}.webp`}
             keyword={`${title} training in ${location}, ${title} certification in ${location}, Online ${title}  Training in ${location}, ${title} Online Training in ${location}, ${title} Syllabus, ${title} course in ${location}, ${title} classes in ${location}, ${title} institute in ${location}, Best ${title} training institute in ${location}, ${title} training and certification in ${location}, Best ${title} training in ${location}, ${title} coaching in ${location}, ${title} training center in ${location}, ${title} training provider in ${location}`}
          />
        <Layout navbarBackgroundColor="#281E1E">
          <Gotemplate url1={url1} url={url} title={title} relatedlocation={"course"} location={location} location1={location1} />
         </Layout>
      </>
    );
  }
}
